const getDomainByEnv = () => {
  if (
    window.location.hostname.includes("testing") ||
    window.location.hostname.includes("internal-medpro.ddns.net") ||
    window.location.hostname.includes("localhost")
  ) {
    return "https://bo-api-testing.medpro.com.vn";
  } else {
    return "https://bo-api.medpro.com.vn";
  }
};
const basePath = window.location.pathname.split("/")[1];
export const findPartner = () => {
  var xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    getDomainByEnv() + "/partner-domain/get-by-domain?domain=" + basePath,
    false
  );
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xhr.send();

  const partner = xhr.status === 200 ? JSON.parse(xhr.response) : null;
  console.log("partner :>> ", partner);
  return partner;
};

const localhost = {
  name: "hotfix",
  domain: ["localhost"],
  partnerId: "umc"
};

const findPartnerByDomain = () => {
  return "umc";
  // if (findPartner()) {
  //   return findPartner().partnerId;
  // } else {
  //   return localhost.partnerId;
  // }
};

export default findPartnerByDomain();
